import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationResponseDto } from "../../shared/dtos/notification/NotificationResponseDto";
import { NotificationSummaryDto } from "../../shared/dtos/notification/NotificationSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
  CrudState,
} from "../utils/crudFactory";

interface NotificationState extends CrudState<
  NotificationResponseDto,
  NotificationSummaryDto
> {
  unreadCount: number;
  loadingMarkRead: boolean;
}

const initialState: NotificationState = {
  ...getInitialCrudState<NotificationResponseDto, NotificationSummaryDto>(),
  unreadCount: 0,
  loadingMarkRead: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    ...generateCrudReducers<NotificationResponseDto, NotificationSummaryDto>(),
    setUnreadCount(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
    },
    setLoadingMarkRead(state) {
      state.loadingMarkRead = true;
    },
    markReadSuccess(state, action: PayloadAction<string>) {
      state.loadingMarkRead = false;
      state.items = state.items.map((n) =>
        n.id === action.payload ? { ...n, isRead: true } : n,
      );
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },
    markAllReadSuccess(state) {
      state.items = state.items.map((n) => ({ ...n, isRead: true }));
      state.unreadCount = 0;
    },
  },
});

export const notificationActions = notificationSlice.actions;
export default notificationSlice.reducer;
